/* eslint import/no-cycle: off */
import { LICENSE } from '../constants/reading/CommonConstants';
import * as root from '../root/reading/root';
import AppLayoutContainer from '../providers/app/reading/AppContainer';
import headerContainer from '../providers/header/reading/HeaderContainer';
import benchmarkContainer from '../providers/benchmark/reading/BenchmarkContainer';
import instructionContainer from '../providers/instruction/reading/InstructionContainer';
import dualLanguageContainer from '../providers/dualLanguage/reading/DualLanguageContainer';
import pdfGenerationContainer from '../providers/pdfGeneration/reading/PdfGeneratorContainer';
import FeatureReportContainer from '../providers/featureReport/reading/FeatureReportContainer';
import FeatureReportExpressContainer from '../providers/featureReport/reading/FeatureReportExpressContainer';
import intercomContainer from '../providers/intercom/reading/IntercomContainer';
import homeConnectContainer from '../providers/homeConnect/reading/HomeConnectContainer';
import ProgressContainer from '../providers/progress/reading/ProgressContainer';
import StudentSummaryContainer from '../providers/studentSummary/reading/StudentSummaryContainer';
import StudentSummaryTableContainer from '../providers/studentSummary/reading/benchmarkHistory/StudentSummaryTableContainer';
import TrcSummaryContainer from '../providers/studentSummary/reading/trcSummary/TrcSummaryContainer';
import StudentSummaryProgressContainer from '../providers/studentSummary/reading/progress/ProgressContainer';
import { TITLE } from '../constants/shared/PMConstants';
import { INSTRUCTION } from '../constants/shared/CommonConstants';
import lrsMiddlewareInstance from '../features/lrs/reading/lrsMiddleware';
import errorViewContainer from '../providers/error/reading/ErrorViewContainer';
import pageWrapperContainer from '../providers/page/reading/PageWrapperContainer';
import { isDualLanguageEnabled } from '../utils/shared/dualLanguageUtils';
import isStandaloneExpress from '../utils/reading/expressUtils';
import ampNavContainer from '../providers/ampNav/reading/AmpNavContainer';
import demoHeaderContainer from '../providers/demoMode/reading/DemoModeHeaderContainer';
import demoToolTipsContainers from '../providers/demoMode/reading/DemoToolTipsContainer';

const { GROUPS } = INSTRUCTION;
const { PM_TITLE } = TITLE;
const { EXPRESS, D8, TRC } = LICENSE;

const datadogApplicationId =
    'ee82f446-9b5a-4b65-bbec-2816abd8579b';
const datadogClientToken =
    'puba938d0abd5693044c910a5ec71d4bce9';
const keycloakURL = 'https://my.amplify.com/auth';

const config = {
    appName: 'reading-classroom-reports',
    appUrl: '/reading-classroom-reports',
    ampNavContainer,
    datadogApplicationId,
    datadogClientToken,
    keycloakURL,
    appLayout: AppLayoutContainer,
    root,
    headerContainer,
    pdfGenerationContainer,
    intercomContainer,
    demoHeaderContainer,
    demoToolTipsContainers,
    errorViewContainer,
    pageWrapperContainer,
    middlewares: {
        lrsMiddleware: {
            enabledWhen: true,
            instance: lrsMiddlewareInstance,
        },
    },
    isDemoModeSupported: true,
    views: {
        benchmark: {
            enabledWhen: () => true,
            featureReportEnabled: () => true,
            menuItemName: 'Benchmark',
            container: benchmarkContainer,
            getFeatureReport: licensingInfo =>
                isStandaloneExpress(licensingInfo)
                    ? FeatureReportExpressContainer
                    : FeatureReportContainer,
            isDisabled: () => false,
        },
        progress: {
            enabledWhen: licensingInfo => !isStandaloneExpress(licensingInfo),
            menuItemName: 'Progress',
            container: ProgressContainer,
            additionalURLParams: () => ({ progressView: PM_TITLE }),
            isDisabled: () => false,
        },
        instructions: {
            enabledWhen: () => true,
            menuItemName: 'Instruction',
            container: instructionContainer,
            additionalURLParams: () => ({ instructionTab: GROUPS }),
            isDisabled: () => false,
        },
        homeconnect: {
            enabledWhen: licensingInfo =>
                licensingInfo.includes(D8) || licensingInfo.includes(EXPRESS),
            menuItemName: 'Home Connect',
            container: homeConnectContainer,
            isDisabled: () => false,
        },
        duallanguage: {
            enabledWhen: licensingInfo => isDualLanguageEnabled(licensingInfo),
            menuItemName: 'Dual Language',
            container: dualLanguageContainer,
            isDisabled: () => false,
        },
        studentsummary: {
            enabledWhen: () => false,
            menuItemName: 'Student Summary',
            container: StudentSummaryContainer,
            isDisabled: () => false,
            childrens: {
                benchmarkHistory: {
                    enabledWhen: () => false,
                    container: StudentSummaryTableContainer,
                    isDisabled: () => false,
                },
                trcSummary: {
                    enabledWhen: licensingInfo => licensingInfo.includes(TRC),
                    container: TrcSummaryContainer,
                    isDisabled: () => false,
                },
                progress: {
                    enabledWhen: () => false,
                    container: StudentSummaryProgressContainer,
                    isDisabled: () => false,
                },
            },
        },
    },
};

export default config;
